import React from 'react';

const ProgressBar = ({ done, total, showLabel = true }) => {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  const isComplete = total > 0 && done === total;

  return (
    <div className="ac-progress">
      <div className="ac-progress-track">
        <div
          className={`ac-progress-fill ${isComplete ? 'is-complete' : ''}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {showLabel && (
        <span className="ac-progress-label">
          {done}/{total}
        </span>
      )}
    </div>
  );
};

export default ProgressBar;
